var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VImg',{class:_vm.classes,attrs:{"src":_vm.theSrc,"contain":_vm.contain,"aspect-ratio":_vm.aspectRatio,"width":_vm.width,"height":_vm.height,"rel":"noreferrer"},on:{"error":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }